module.exports = __webpack_public_path__ + "img/iSimulate-Logo.20aa994f.svg";